import { useContext, useEffect, useState } from "react"
import { AppContext } from "../App"
import { callApi, formatMoney } from "../Helpers";
import { getInlineLoader } from "../Helpers";
import { MdDirectionsBike } from "react-icons/md";

export default function View({ uuid }) {

    const appContext = useContext(AppContext);

    /* Place states here */
    const [ ready, setReady ] = useState(false);
    const [loading, setLoading] = useState(false);

    const [model, setModel] = useState('');
    const [price, setPrice] = useState('');
    const [totalReceived, setTotalReceived] = useState(''); // Initialized empty to force input declaration
    const [data, setData] = useState(null);

    async function init() {
        setReady(false);
        await Promise.all([
            appContext.getAllMotorcycles(),
            (async () => {
                if(uuid) {
                    await getData();
                }
            })(),
        ]);
        setReady(true);
    }

    async function getData() {
        await callApi('get-motorcycle-data', { uuid }).then((response) => {
            if(response.status === 1) {
                setData(response.data)
            } else {
                appContext.tellError('Could not fetch data');
            }
        });
    }

    async function create() {
        // Enforcing compulsory non-empty fields validation strings
        if(!model || model.trim().length === 0) {
            return appContext.tellError("Motorcycle Model is required");
        }
        if(!price || parseFloat(price) <= 0) {
            return appContext.tellError("A valid Price greater than 0 is required");
        }
        if(totalReceived === '' || parseInt(totalReceived) < 0) {
            return appContext.tellError("Initial Stock Quantity is required and cannot be negative");
        }

        setLoading(true);
        await callApi(
            'create-motorcycle',
            {
                model: model.trim(),
                price: parseFloat(price),
                totalReceived: parseInt(totalReceived)
            }
        ).then(response => {
            if(response.status === 1) {
                appContext.tellMessage('Successful');
                appContext.navBack();
                appContext.getAllMotorcycles();
            } else {
                appContext.tellError(response.msg);
            }
        });
        setLoading(false);
    }

    async function update() {
        if(!model || model.trim().length === 0) {
            return appContext.tellError("Motorcycle Model is required");
        }
        if(!price || parseFloat(price) <= 0) {
            return appContext.tellError("A valid Price greater than 0 is required");
        }
        if(totalReceived === '' || parseInt(totalReceived) < 0) {
            return appContext.tellError("Stock Quantity value parameter is required");
        }

        setLoading(true);
        await callApi(
            'update-motorcycle',
            {
                uuid,
                model: model.trim(),
                price: parseFloat(price),
                totalReceived: parseInt(totalReceived)
            }
        ).then(response => {
            if(response.status === 1) {
                appContext.tellMessage('Successful');
                appContext.navBack();
                appContext.getAllMotorcycles();
            } else {
                appContext.tellError(response.msg);
            }
        });
        setLoading(false);
    }

    useEffect(() => {
        init();
    }, [ uuid ]);

    useEffect(() => {
        if (data) {
            setModel(data.model || '');
            setPrice(data.price || '');
            setTotalReceived(data.totalReceived !== undefined ? String(data.totalReceived) : '0');
        }
    }, [data]);

    useEffect(() => {
        appContext.setShowOverlayLoader(loading);
        return () => {
            appContext.setShowOverlayLoader(false);
        }
    }, [ loading ]);

    if(ready) {
        return (
            <div className="container">
                <div className="app-form-page">
                    <div className="app-form-shell">
                        <div className="app-form-header">
                            <div>
                                <h6 className="app-form-title">
                                    {(uuid) ? "Edit Fleet Configuration" : "Add Stock Model"}
                                </h6>
                            </div>
                            <div className="app-form-badge">
                                <MdDirectionsBike size={18} />
                                {uuid ? "Modifying details" : "New stock"}
                            </div>
                        </div>

                        <div className="app-form-section">
                            <div className="app-form-summary-grid">
                                <div className="app-form-summary-card">
                                    <span>Catalog size</span>
                                    <strong>{appContext.allMotorcycles?.length || 0} Models</strong>
                                </div>
                                <div className="app-form-summary-card">
                                    <span>Base Retail Valuation</span>
                                    <strong>{price ? formatMoney(price) : "0.00"}</strong>
                                </div>
                            </div>

                            <div className="row">
                                <div className="col-md-4 mt-3 mb-3">
                                    <div className="app-form-input-wrap">
                                        <label className="form-label">Motorcycle Model *</label>
                                        <input
                                            className="form-control"
                                            value={model}
                                            onChange={(e) => setModel(e.target.value)}
                                            placeholder="e.g. Boxer BM 150 HD"
                                            required
                                        />
                                    </div>
                                </div>

                                <div className="col-md-4 mt-3 mb-3">
                                    <div className="app-form-input-wrap">
                                        <label className="form-label">Price (Per Unit) *</label>
                                        <input
                                            className="form-control"
                                            type="number"
                                            value={price}
                                            onChange={(e) => setPrice(e.target.value)}
                                            placeholder="Enter price"
                                            required
                                        />
                                    </div>
                                </div>

                                <div className="col-md-4 mt-3 mb-3">
                                    <div className="app-form-input-wrap">
                                        <label className="form-label">Stock Quantity *</label>
                                        <input
                                            className="form-control"
                                            type="number"
                                            min="0"
                                            value={totalReceived}
                                            onChange={(e) => setTotalReceived(e.target.value)}
                                            placeholder="Enter total units"
                                            required
                                        />
                                    </div>
                                </div>
                                
                                <div className="col-12 mt-3 mb-3 text-end app-form-submit-row">
                                    <button
                                        className="btn btn-padded btn-rounded btn-primary btn-block app-form-submit-btn"
                                        onClick={(uuid) ? update : create}
                                    >
                                        {(uuid) ? "UPDATE RECORD" : "COMMIT STOCK ENTRY"}
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    } else {
        return (
            <div className="container mSupportLoading">
                {getInlineLoader()}
            </div>
        );
    }
}